<template>
  <div>
    <i class="fa fa-check text-success"></i>
    De winnaars worden elk kwartaal bekendgemaakt via:

    <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>
        <a href="https://commercialreview.nl" target="_blank">commercialreview.nl</a>
        (<a href="https://commercialreview.nl/articles/column-de-beste-decembercommercials-van-2021"
        target="_blank">voorbeeld</a>)
      </small>
    </div>
    <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>Commercialreview
        <a href="https://www.linkedin.com/company/commercialreview/" target="_blank">
          LinkedIn-pagina
        </a>
      </small>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WinnersExposed',
};
</script>
